import { z } from "zod";

import { AppointmentType } from "~/services/scheduling";

export const adminProviderSchema = z.object({
  id: z.number(),
  name: z.string(),
  scheduleAvailable: z.boolean(),
  bookingConflicts: z.number(),
  scheduleLastModifiedAt: z.string().nullable(),
});

const paginationLinksSchema = z.object({
  first: z.string().nullable(),
  last: z.string().nullable(),
  prev: z.string().nullable(),
  next: z.string().nullable(),
});

const paginationMetaSchema = z.object({
  current_page: z.number(),
  from: z.number().nullable(),
  last_page: z.number(),
  path: z.string(),
  per_page: z.number(),
  to: z.number().nullable(),
  total: z.number(),
});

export const adminProvidersResponseSchema = z.object({
  data: z.array(adminProviderSchema),
  links: paginationLinksSchema,
  meta: paginationMetaSchema,
});

export const scheduleMetaSchema = z.object({
  description: z.string().nullable(),
  originalFilename: z.string(),
  updatedAt: z.string(),
});

export const providerScheduleSchema = z.object({
  providerName: z.string(),
  scheduleData: scheduleMetaSchema.nullable(),
});

export const providerScheduleResponseSchema = z.object({
  data: providerScheduleSchema,
});

export const providerSlotSchema = z.object({
  id: z.number(),
  duration: z.number(),
  startTime: z.string(),
  status: z.string().nullable(),
  appointmentType: z.string().nullable(),
  isConvertible: z.boolean(),
});

const emptySlotsMapAsObject = (value: unknown) =>
  Array.isArray(value) && value.length === 0 ? {} : value;

export const providerSlotsByDateSchema = z.preprocess(
  emptySlotsMapAsObject,
  z.record(z.string(), z.array(providerSlotSchema)),
);

export const providerSlotsMetaSchema = z.object({
  maxDate: z.string(),
});

export const providerSlotsResponseSchema = z.object({
  data: providerSlotsByDateSchema,
  meta: providerSlotsMetaSchema,
});

export const convertedSlotSchema = z.object({
  providerId: z.number(),
  date: z.string(),
  startTime: z.string(),
  endTime: z.string(),
  appointmentTypeSlug: z.string(),
  isManuallyOverridden: z.boolean(),
});

export const convertSlotResponseSchema = z.object({
  data: convertedSlotSchema,
});

export const providerAppointmentSchema = z.object({
  startAt: z.string(),
  appointmentType: AppointmentType.nullable(),
  patientId: z.string().nullable(),
});

export const providerAppointmentsResponseSchema = z.object({
  data: z.array(providerAppointmentSchema),
});
